import RecebimentoParceladoModel from "../../models/financeiro/recebimentoParceladoModel";

import { IService } from "./../base/iService";

export default class RecebimentoParceladoService extends IService<RecebimentoParceladoModel> {
    constructor() {
        super("RecebimentoParcelado");
    }
}
